/**
 * Created by ostapenko.r on 11/5/2014.
 */
angular.module('flipto.components.common.list', []);
